import { get, post } from 'api';
import { cleanObject } from 'utils/object';

import { CUSTOMERS_LOADED, LOAD_CUSTOMERS, RESET_CUSTOMERS, SYNC_FAILED } from './actionTypes';
import type { IGetCustomersParams } from './types';

export const initialActionsState = {
  loadCustomers: () => {},
  resetCustomers: () => {},
  // These two don't have list/loading state to dispatch to (per-modal, ephemeral data), so unlike
  // the other actions above, the no-Provider default has to resolve to a safe shape rather than a
  // sync no-op, since callers await the result directly instead of going through the reducer.
  sendPhotoIdEmailLink: async () => ({ success: false }),
  getPhotoIdEmailStatus: async () => ({ success: false }),
};

export const getActions = (dispatch: { (value: { type: any; payload?: any }): void }) => ({
  loadCustomers: async (params: IGetCustomersParams = {}, onDone, ignoreIsLoading = false) => {
    if (!ignoreIsLoading) {
      dispatch({
        type: LOAD_CUSTOMERS,
      });
    }

    const { data, error } = await get('/customers', { params: cleanObject(params) });

    if (!error) {
      dispatch({
        type: CUSTOMERS_LOADED,
        payload: Array.isArray(data) ? data : [],
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    if (onDone) onDone(Array.isArray(data) ? data : [], error);
  },

  resetCustomers: () =>
    dispatch({
      type: RESET_CUSTOMERS,
    }),

  // Photo ID verification modal (DOT-4165/DOT-4281): per-customer, per-modal state, not a shared
  // list — intentionally doesn't dispatch to the reducer, just passes the API result straight back.
  sendPhotoIdEmailLink: (customerReference: string, representativeReference: string) =>
    post('/customers/photo-id/send-email-link', { customerReference, representativeReference }),

  getPhotoIdEmailStatus: (customerReference: string) =>
    get('/customers/photo-id/require-email-status', { params: { customerReference } }),
});
